// extracted by mini-css-extract-plugin
export var content = "FullColumnContentCell-module--content--3oA8a";
export var contentWrapper = "FullColumnContentCell-module--content-wrapper---DqwH";
export var fullColumnContentCell = "FullColumnContentCell-module--full-column-content-cell--4GTMH";